import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Field, TextInput } from "@odingard/design-system";
import { api } from "../../lib/api";

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("This reset link is missing its token.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await api.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : "This reset link is invalid or expired.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="brand" style={{ justifyContent: "center", marginBottom: "var(--ods-space-5)" }}>
          <span className="brand__mark">O</span> Odingard Studio
        </Link>
        <Card>
          <CardBody>
            <h1 style={{ fontSize: "var(--ods-text-xl)", marginTop: 0 }}>Choose a new password</h1>
            {done ? (
              <div className="banner banner--success" role="status">
                Your password has been reset. Redirecting to sign in…
              </div>
            ) : (
              <form onSubmit={onSubmit}>
                {error && (
                  <div className="banner banner--warning" role="alert">
                    {error}
                  </div>
                )}
                <Field label="New password" help="At least 8 characters.">
                  {(id) => (
                    <TextInput
                      id={id}
                      type="password"
                      autoComplete="new-password"
                      minLength={8}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  )}
                </Field>
                <Field label="Confirm new password">
                  {(id) => (
                    <TextInput
                      id={id}
                      type="password"
                      autoComplete="new-password"
                      minLength={8}
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                      required
                    />
                  )}
                </Field>
                <Button type="submit" block disabled={busy}>
                  {busy ? "Saving…" : "Reset password"}
                </Button>
              </form>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
